import {Hashrate, Interval} from '../ApiStore';

export default (hashrate: Hashrate, interval: Interval) =>
  `${hashrate}_${interval}`;
